<div class="card shadow login-card m-auto" [formGroup]="parentForm">
  <div class="card-body reviewStepperContent py-5">
    <div class="col d-flex">
      <div class="w-100">
        <div class="d-flex flex-row justify-content-between">
          <h1 class="card-title" id="card-title">Review</h1>
          <button
            class="btn btn-primary mb-2"
            matStepperNext
            (click)="submitForm()"
            [disabled]="!isFormValid"
            type="button"
          >
            <app-loading-spinner
              [loading]="isloading"
              *ngIf="isloading"
            ></app-loading-spinner>
            Submit
          </button>
        </div>
        <div class="d-flex flex-row">
          <div class="mr-3 mb-3" style="flex-basis: 40%">
            <div>
              <div
                *ngIf="featureLevel === billingLevel.TRIAL"
                class="card-outline mt-4 selected"
              >
                <div class="d-flex card border-danger shadow card-label">
                  <div class="card-body">
                    <div class="d-flex flex-row">
                      <div class="d-flex flex-column" style="flex-basis: 83%">
                        <h1
                          class="card-title text-danger font-weight-bold"
                          id="card-title"
                        >
                          TRIAL
                        </h1>
                        <span class="card-text card-line-height">
                          <p class="mb-0">
                            Access to <b>all features</b> for {{ trialPeriod }}!
                          </p>

                          <p class="mb-0">Free for one user.</p>
                        </span>
                      </div>
                      <div class="d-flex flex-column align-items-end mt-4">
                        <h1 class="card-title font-weight-bold">FREE!</h1>
                      </div>
                    </div>
                    <div class="d-flex flex-row"></div>
                  </div>
                </div>
              </div>
              <div
                *ngIf="featureLevel === billingLevel.PREMIUM"
                class="card-outline mt-4 selected"
              >
                <div class="d-flex card border-primary shadow card-label">
                  <div class="card-body">
                    <div class="d-flex flex-row">
                      <div class="d-flex flex-column" style="flex-basis: 58%">
                        <h1
                          class="card-title text-primary font-weight-bold"
                          id="card-title"
                        >
                          BUY PC*MILER
                        </h1>
                        <span
                          class="card-text card-line-height"
                          style="flex-basis: 58%"
                        >
                          <p class="mb-0">
                            Comprehensive set of routing options and planning
                            tools
                          </p>
                        </span>
                      </div>
                      <div class="d-flex flex-column align-items-end mt-4">
                        <h1
                          class="card-title font-weight-bold card-line-height mb-0"
                        >
                          {{ featureCost | displayCurrency : displayCurrency }}
                        </h1>
                        <span
                          class="card-subtitle-1 font-weight-bold card-line-height"
                          >A MONTH PER USER</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row flex-fill justify-content-between">
            <div class="">
              <p class="font-weight-bold">Billed to:</p>
              <p class="mb-0">
                {{
                  this.parentForm.get("accountForm")?.controls?.firstName.value
                }}
                {{
                  this.parentForm.get("accountForm")?.controls?.lastName.value
                }}
              </p>
              <p class="mb-0">{{ billingFormControls?.address1 }}</p>
              <p class="mb-0">{{ billingFormControls?.address2 }}</p>
              <p class="mb-0">
                {{ billingFormControls?.city }},{{
                  billingFormControls?.stateProvince
                }}
                <span class="ml-1">{{ billingFormControls?.zipCode }}</span>
              </p>

              <p class="">{{ billingFormControls?.country }}</p>
              <p class="mb-0">
                {{ billingFormControls?.phone | mask : phoneMask }}
              </p>
              <p *ngIf="featureLevel === billingLevel.PREMIUM">
                <span class="mr-1"
                  >{{ billingFormControls?.cardType }} card ending with:</span
                >
                {{ maskCreditCard(billingFormControls?.cardNumber) }}
              </p>
            </div>
            <div class="d-flex flex-column" style="flex-basis: 37%">
              <p class="mb-0 d-flex flex-row mt-4">
                <span class="text-right cost-label">Cost Per User : </span>
                <span
                  class="ml-2"
                  *ngIf="featureLevel === billingLevel.PREMIUM"
                >
                  {{ featureCost | displayCurrency : displayCurrency }}</span
                >
                <span
                  class="ml-2"
                  *ngIf="featureLevel !== billingLevel.PREMIUM"
                  >{{ 0.0 | displayCurrency : displayCurrency }}</span
                >
              </p>
              <p class="mb-0 d-flex flex-row">
                <span class="text-right cost-label">Number of Users : </span
                ><span class="ml-2">{{ billingFormControls?.noOfUsers }}</span>
              </p>
              <p class="mb-0 d-flex flex-row">
                <span class="text-right cost-label">Cost Per Month : </span
                ><span
                  class="ml-2"
                  *ngIf="featureLevel === billingLevel.PREMIUM"
                >
                  {{
                    billingFormControls?.totalCostPerMonth
                      | displayCurrency : displayCurrency
                  }}</span
                >
                <span
                  class="font-weight-bold text-nowrap small ml-2"
                  *ngIf="featureLevel !== billingLevel.PREMIUM"
                  >FREE 7 DAYS</span
                >
              </p>
              <p class="border-top mt-1 mb-1 border-dark"></p>
              <p class="mb-0 d-flex flex-row">
                <span class="text-right font-weight-bold cost-label"
                  >Total : </span
                ><span
                  class="font-weight-bold ml-2"
                  *ngIf="featureLevel === billingLevel.PREMIUM"
                >
                  {{
                    billingFormControls?.totalCostPerMonth
                      | displayCurrency : displayCurrency
                  }}
                </span>
                <span
                  class="font-weight-bold ml-2"
                  *ngIf="featureLevel !== billingLevel.PREMIUM"
                  >{{ 0.0 | displayCurrency : displayCurrency }}</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
